module.exports = __webpack_public_path__ + "img/video-replace.78eca24b.jpg";